import { captureMessage } from '@sentry/nextjs';

const env: NodeJS.ProcessEnv = {
  NEXT_PUBLIC_CONTENT_BASE_URL: process.env.NEXT_PUBLIC_CONTENT_BASE_URL,
  NEXT_PUBLIC_CONSOLE_URL: process.env.NEXT_PUBLIC_CONSOLE_URL,
  NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
  NODE_ENV: process.env.NODE_ENV,
  NEXT_PUBLIC_OIDC_AUTHORITY_URL: process.env.NEXT_PUBLIC_OIDC_AUTHORITY_URL,
  NEXT_PUBLIC_OIDC_CLIENT_ID: process.env.NEXT_PUBLIC_OIDC_CLIENT_ID,
  NEXT_PUBLIC_BACKEND_URL: process.env.NEXT_PUBLIC_BACKEND_URL,
  NEXT_PUBLIC_SPACE: process.env.NEXT_PUBLIC_SPACE,
  NEXT_PUBLIC_OIDC_REDIRECT_URI: process.env.NEXT_PUBLIC_OIDC_REDIRECT_URI,
  NEXT_PUBLIC_OIDC_AUTH_COOKIE_NAME: process.env.NEXT_PUBLIC_OIDC_AUTH_COOKIE_NAME,
  NEXT_PUBLIC_CONFIGS_CLUSTER_URL: process.env.NEXT_PUBLIC_CONFIGS_CLUSTER_URL,
  NEXT_PUBLIC_IMAGES_PROXY_URL: process.env.NEXT_PUBLIC_IMAGES_PROXY_URL,
  NEXT_PUBLIC_GLOSSARY_PROXY_URL: process.env.NEXT_PUBLIC_GLOSSARY_PROXY_URL,
  NEXT_PUBLIC_CONFIGS_FEATURE_STANDS_HEADER_NAME: process.env.NEXT_PUBLIC_CONFIGS_FEATURE_STANDS_HEADER_NAME,
  TZ: process.env.TZ,
  NEXT_PUBLIC_UX_FEEDBACK_ID: process.env.NEXT_PUBLIC_UX_FEEDBACK_ID,
  NEXT_PUBLIC_SITE_YM_ID: process.env.NEXT_PUBLIC_SITE_YM_ID,
  NEXT_PUBLIC_DOCS_YM_ID: process.env.NEXT_PUBLIC_DOCS_YM_ID,
  NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  NEXT_PUBLIC_SPECS_PROXY_URL: process.env.NEXT_PUBLIC_SPECS_PROXY_URL,
  NEXT_PUBLIC_CONSOLE_REGISTRATION_URL: process.env.NEXT_PUBLIC_CONSOLE_REGISTRATION_URL,
  NEXT_PUBLIC_POST_LOGOUT_REDIRECT_URL: process.env.NEXT_PUBLIC_POST_LOGOUT_REDIRECT_URL,
};
export function getGlobalArgs(argName: keyof NodeJS.ProcessEnv): string | undefined;
export function getGlobalArgs<F>(argName: keyof NodeJS.ProcessEnv, fallback: F): string | F;

export function getGlobalArgs<F>(argName: keyof NodeJS.ProcessEnv, fallback?: F) {
  const globalArgValue = env[argName];
  if (!globalArgValue) {
    captureMessage(`Failed to read global arg value, reading: ${argName}, in: ${JSON.stringify(env)} `, {
      level: 'error',
    });
    return fallback;
  }
  return globalArgValue;
}
